<template>
  <div class="prepaid-recharge">
    <img
      class="recharge-tips"
      src="@/assets/pizzaking/task-recharge-banner.svg"
      alt="充值福利"
      srcset=""
    />
    <div class="tips">我的补给箱</div>
    <p class="weekly-rule">当周充值一直累计，每日不重置；每周一 00:00 同时重置充值累计与补给奖励领取状态。</p>
    <!-- 价格100，500，1000，2000，5000，10000就行 -->
    <div class="recharge">
      <div class="recharge-item">
        <div>充值金额</div>
        <div>奖励金额</div>
        <div>首次补给</div>
      </div>
      <div class="recharge-item" v-for="(item, index) in list" :key="index">
        <div style="font-weight: bold">{{ item.upgrade }}</div>
        <div>{{ item.reward }} 披萨币</div>
        <div>
          <button
            v-if="item.status == 1"
            type="button"
            class="task-status claim-status"
            data-pk-sound-click
            @click="getChongzhils(item)"
          >立即领取</button>
          <span v-else class="task-status" data-pk-sound-click @click="goRecharge(item)">
            {{ item.status == 2 ? "已领取" : "去充值" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { playUiSound } from "@/utils/pizzaSound";

export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getChongzhilsInfo();
  },
  methods: {
    async getChongzhilsInfo() {
      const params = {
        player_id: localStorage.getItem("id"),
      };
      const { data } = await this.$axios.post(
        "/index/Activity/czls_info",
        this.$qs.stringify(params)
      );
      this.list = data.data;
    },
    goRecharge(item) {
      if (item.status == 2) {
        this.$message.error("奖励已领取");
        return;
      }
      this.$router.push({
        path: "/Payment",
      });
    },
    async getChongzhils(item) {
      const params = {
        player_id: localStorage.getItem("id"),
        id: item.id,
      };
      const { data } = await this.$axios.post(
        "/index/Activity/czls",
        this.$qs.stringify(params)
      );

      if (data.status) {
          playUiSound("reward");
          this.$message.success("领取成功");
          this.getChongzhilsInfo();
        } else {
          this.$message.error(data.msg);
        }

     
    },
  },
};
</script>

<style lang="less" scoped>
.weekly-rule { margin: 0 0 18px; padding: 12px 16px; color: #ffd777; background: rgba(255, 150, 28, .1); border: 1px solid rgba(255, 179, 61, .22); border-radius: 6px; line-height: 1.7; font-weight: 800; }
.prepaid-recharge {
  color: #fff;
  text-align: center;
  .tips {
    font-size: 22px;
    margin-top: 20px;
  }
  .recharge-tips {
    width: 95%;
    max-width: 400px;
  }
  .recharge {
    max-width: 600px;
    margin: 0 auto;
    margin-top: 30px;
    &-item:first-child {
      margin-bottom: 20px;
    }
    &-item {
      display: flex;
      align-items: center;
      width: 100%;
      & > div {
        flex: 1;
        font-size: 14px;
        img {
          width: 30%;
          max-width: 100px;
        }
        .task-status {
          color: #e9b10e;
          cursor: pointer;
          font-weight: bold;
        }
        .claim-status {
          min-width: 86px;
          min-height: 38px;
          padding: 0 14px;
          color: #151620;
          border: 0;
          border-radius: 8px;
          background: linear-gradient(180deg, #ffd53b, #ff8300);
        }
      }
    }
  }
}
</style>
